import SlideShowGallery_SlideShowGalleryLiftedShadowSkinComponent from '../components/NativeGalleries/SlideShowGallery/viewer/skinComps/SlideShowGalleryLiftedShadowSkin/SlideShowGalleryLiftedShadowSkin.skin';
import SlideShowGallery_SlideShowGalleryLiftedShadowSkinController from '../components/NativeGalleries/SlideShowGallery/viewer/SlideShowGallery.controller';


const SlideShowGallery_SlideShowGalleryLiftedShadowSkin = {
  component: SlideShowGallery_SlideShowGalleryLiftedShadowSkinComponent,
  controller: SlideShowGallery_SlideShowGalleryLiftedShadowSkinController
};


export const components = {
  ['SlideShowGallery_SlideShowGalleryLiftedShadowSkin']: SlideShowGallery_SlideShowGalleryLiftedShadowSkin
};

